const Note = ({ title = '', children }) => {
    return (
        <div className="aff-note">
            {title && <span className="note-title">{title}</span>}
            {children}
        </div>
    );
};

export default Note;
